import axiosInstance from './axiosInstance';
const BASE_URL = process.env.REACT_APP_API_URL;

export const AddImage = async (name, type, image) => {
  try {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("type", type);
    formData.append("image", image);

    const { data } = await axiosInstance.post(`${BASE_URL}/image/addImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const RemoveImage = async (file_key) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/image/removeImage`,
      { fileKey: file_key },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllCustomersByStoreSummary = async (
  store_id,
  user_id,
  token
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/GetAllCustomersByStoreSummary`,
      { store_id: store_id },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSaleOverview = async (store_id) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getSaleOverview`,
      { store_id: store_id },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetOverviewAccounts = async (store_id, range) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getOverviewAccounts`,
      { store_id: store_id, range: range },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetOverviewCounts = async (store_id) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getOverviewCounts`,
      { store_id: store_id },
    );
    //console.log(response);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetNumSO = async () => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getNumSO`,
      {},
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetNumPO = async () => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getNumPO`,
      {},
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetNumOpenSO = async () => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getNumOpenSO`,
      {},
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetNumOpenPO = async () => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getNumOpenPO`,
      {},
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSaleRevByMonth = async () => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getSaleRevByMonth`,
      {},
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPurchCostByMonth = async () => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/overview/getPurchCostByMonth`,
      {},
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
